import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { ChatInput, type InputRefType } from '../../ChatInput/ChatInput';
import { footerRootSx } from './styles';

export type FooterProps = {
  isLoading: boolean;
  sendMessage: (query: string) => void;
  inputRef: InputRefType;
};

export const Footer = ({ sendMessage, isLoading, inputRef }: FooterProps) => {
  return (
    <Stack direction="column" sx={footerRootSx}>
      <Divider sx={{ width: '100%', border: 'none', borderTop: theme => `1px solid ${theme.palette.divider}` }} />
      <ChatInput sendButton={{ onClick: sendMessage, isLoading: isLoading }} inputRef={inputRef} />
    </Stack>
  );
};
